import React, { useEffect, useRef, useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import ListLayout from "../../Layout/PageLayout/ListLayout";
import CategorySubcategoryList from "./CategorySubcategoryList";
import { useGlobalAlert } from "../../Common/Context/GlobalAlertContext";
import { handleDelete_categoryList, handleGet_categoryList } from "./categoryListModel";
import { useDebounce } from "../../../Utils/debounceAPI";
 
  
const CategoryList = () => {
  const navigate = useNavigate();  
  const { showAlert } = useGlobalAlert();

  const [dataList, setDataList] = useState([]);
  const [filteredList, setFilteredList] = useState([]);

  const [loading, setLoading] = useState(false);
  const [actionLoading, setActionLoading] = useState({});

  const [totalRecords, setTotalRecords] = useState(0);
  const [totalPages, setTotalPages] = useState(1);

  const [search, setSearch] = useState("");
  const [filter, setFilter] = useState({
    page: 1,
    limit: 'all',    
  });

  // API
  const fetchList = async (filt) => {
    if (!filt) return;

    try {
      await handleGet_categoryList({
        setLoading,
        filter: filt,
        showAlert,
        setDataList, // ✅ pass directly
        setFilteredList, // ✅ pass directly
        setTotalRecords,
        setTotalPages,
      });
    } catch (err) {
      console.error("job post fetchList error:", err);
    }
  };
  
  const debouncedFetchList = useDebounce(fetchList, 400);

  useEffect(() => {
    if (!filter) return;
    debouncedFetchList(filter); // ✅ debounce here only
  }, [filter]);
  
  const handleEdit=(element)=>{
    let data = element;
    let type= {
      value: "category",
      label: "Category",
    }
    if(
      element?.category &&
      Object.keys(element?.category)?.length > 0){
      type= {
        value: "subcategory",
        label: "Sub Category",
      }      
    } 
    data={...data,type}
    const { created_at, updated_at, ...cleanFilter } = data;
    navigate("/admin/catg-sub", {
      state: { ...cleanFilter },
    });
  }

  const handleDelete = (element) => {

    const isSubCategory = element?.category > 0;
  
    const msg = isSubCategory
      ? "Are you sure you want to delete this sub category?"
      : "Are you sure you want to delete this category? All related sub categories and their images will also be deleted.";
  
    showAlert({
      title: "Confirmation",
      message: msg,
      type: "warning",
      confirmLabel: "Yes",
      cancelLabel: "No",
  
      onConfirm: () => {
  
        let data = {
          id: element?.id,
          category:element?.category || 0,
        };
  
        if (isSubCategory) {
          data = {
            ...data,
            action: "subcategory",
          };
        }
  
        handleDelete_categoryList({
          setActionLoading,
          data,
          showAlert,
          setFilteredList,
          setDataList,
        });
      },
    });
  };

  return (
    <ListLayout
        title="Cat-Sub List"
        searchValue={search}
        onSearch={setSearch}
        onClearSearch={() => setSearch("")} 
        // onNewText="Submit"   
        // onNewLoading={submitLoading}     
        onNew={(e) => {
          navigate('/admin/catg-sub')
        }}
         
      >
      <CategorySubcategoryList
        data = {filteredList}
        search={search}
        loading={loading}
        actionLoading={actionLoading}
        onCategoryEdit={handleEdit}
        onCategoryDelete={handleDelete}
        onSubCategoryEdit={handleEdit}
        onSubCategoryDelete={handleDelete}

      />
       
    </ListLayout>
  );
};

export default CategoryList;